import React from 'react';
import { SvgIcon } from '@make-software/tg-mini-app-ui';

import ArrowRight from '@/shared/assets/icons/ic-arrow-right.svg';
import { IHackathonProject, IVoteRank } from '@/entities';
import {
  ProjectDescription,
  ProjectIndex,
  ProjectIndexText,
  ProjectLogo,
  ProjectLogoContainer,
  ProjectTitle,
} from '@/shared';
import { getThumbUrl } from '@/utils';

import {
  CardGrid,
  LogoCell,
  ContentCell,
  RightRail,
  HeaderRowGrid,
  TitleBlock,
} from './styled';

type Props = {
  project: IHackathonProject;
  onClick?: () => void;
  voteRank?: IVoteRank;
};

export const HackathonProjectCard: React.FC<Props> = ({ project, onClick, voteRank }) => {

  return (
    <CardGrid onClick={onClick}>
      <LogoCell>
        <ProjectLogoContainer>
          <ProjectLogo src={getThumbUrl(project?.project_logo)} />
        </ProjectLogoContainer>
      </LogoCell>

      <ContentCell>
        <HeaderRowGrid>
          <TitleBlock>
            <ProjectIndex>
              <ProjectIndexText weight={3} size="lg">
                #{voteRank?.position ?? project?.id}
              </ProjectIndexText>
            </ProjectIndex>
            <ProjectTitle weight={3} size="lg" color="#FFFFFF">
              {project.title}
            </ProjectTitle>
          </TitleBlock>

          {/*<RightStats>*/}
          {/*  <EarnIconContainer*/}
          {/*    src={EarnIcon}*/}
          {/*    size={14}*/}
          {/*    fillColor={airdropInfo?.airdrop?.round === 1 ? '#FB6F6A' : '#A0B3FF'}*/}
          {/*  />*/}
          {/*  <BalanceValue>*/}
          {/*    {airdropInfo?.airdrop?.round === 1*/}
          {/*      ? (project?.round1_balance || 0)*/}
          {/*      : (project?.round2_balance || 0)}*/}
          {/*  </BalanceValue>*/}
          {/*</RightStats>*/}
        </HeaderRowGrid>

        <ProjectDescription weight={3} size="lg">
          {project?.brief_description?.replace(/\\n/g, '\n')}
        </ProjectDescription>
      </ContentCell>

      <RightRail align="center" justify="center">
        <SvgIcon src={ArrowRight} alt="" />
      </RightRail>
    </CardGrid>
  );
};
